module.exports = __webpack_public_path__ + "static/media/tech-nextgen-4.35a55957.png";